<div class="container-terms">
    <div class="terms_heading">
        <h1>Terms & Conditions of Ascendion AVA</h1>
    </div>
    <hr>
    <div>
        <h5 class="title-headings">Terms of Use </h5>
        <p>These Terms of Use, together with the Privacy Policy available at ("<span>Privacy Policy</span>") and the
            rules, policies,
            terms
            and conditions set forth in, referred to and/or links herein, all of which are incorporated herein by
            reference,
            are, collectively, the "<span>Agreement</span>".
        </p>
        <br>
        <p>This Agreement constitutes a legal agreement between you ("<span>you</span>" or "<span>User</span>") and
            Ascendion, Inc. ("<span>Ascendion</span>",
            “<span>we</span>”,
            “<span>our</span>” or "<span>us</span>"). This Agreement governs your use of the Ascendion mobile
            application offered by us and the
            services
            and content available through the Ascendion AVA website and application (collectively, the
            "<span>App</span>"). If you are
            accessing or using the App on behalf of a business, that business agrees to this Agreement. </p>
        <br>
        <span>By using the App you hereby agree to be bound by the terms and conditions of this Agreement.</span>
        <br>
        <br>
        <p>Please read this Agreement carefully. If you do not agree to be bound by this Agreement, you will not have
            any
            right to use the App. Ascendion's acceptance is expressly conditioned upon your assent to this Agreement in
            its
            entirety. If this Agreement is considered to be an offer by us, acceptance is expressly limited to this
            Agreement. </p>
        <p>By using the App, you represent and warrant that: (i) you are at least 18 years old or the legally required
            age
            to contract in the jurisdiction in which you reside, whichever is greater, and are otherwise capable of
            entering
            into binding contracts; (ii) you have the right, authority and capacity to enter into this Agreement and to
            abide by the terms and conditions of this Agreement, and that you will so abide. </p>
        <p>To the extent permitted and except where prohibited by applicable law, this Agreement includes: </p>
        <p>•Your agreement that the App is provided "as is" and without warranty (Section 7).
            [https://ascendion.com/ava]
        </p>
        <p> •Your agreement to release Ascendion from liability based on claims relating to the App and otherwise
            (Section
            9). </p>

        <p> • Your agreement that either party may compel binding arbitration for most types of disputes (Section 8).
        </p>

        <p>• Your consent to any modifications or amendments to this Agreement (Section 10). </p>

        <p> • Your consent to the collection, use, sharing and transfer of your data as outlined in the Privacy Policy
            as
            updated from time to time. </p>
        <br>
        <h3 class="title-headings">TABLE OF CONTENTS </h3>
        <br>
        <p>1. Use of Content </p>
        <p>2. Personal Information; User Accounts </p>
        <p>3. Prohibited Conduct on the App. </p>
        <p>4. Intellectual Property Rights </p>
        <p>5. Copyright Complaints and Copyright Agent </p>
        <p>6. The App / Mobile Devices </p>
        <p>7. Disclaimer of Warranties; Limitation on Liability </p>
        <p>8. Mutual Arbitration Agreement </p>
        <p>9. Governing Law; Jurisdiction </p>
        <p>10. Modification to the App. </p>
        <p>11. Assignment </p>
        <p>12. Term and Termination; Survival </p>
        <p>13. General Provisions </p>
        <p>14. Changes to the Agreement </p>
        <br>
        <p>1. <span class="underline"> Use of Content. </span></p>
        <p>You agree not to copy/collect App content via robots, spiders, scripts, scrapers, crawlers, or any automated
            or
            manual equivalent (e.g., by hand). You agree not to collect App user information or interfere with the App.
            You
            agree not to disclose App content to any parties outside of the organization on behalf of which you use the
            App.
        </p>
        <p>2. <span class="underline">Personal Information; User Accounts.</span></p>
        <br>
        <p>A. <b class="underline">Collection of your Personal Information.</b> Some of the materials available on the
            App may require prior
            registration to access. If you decide to access such materials you will be required to register. We may
            refuse
            to grant you, and you may not use, a User name, email address or screen name that (i) is already being used
            by
            someone else; (ii) may be construed as impersonating another person; (iii) belongs to another person; (iv)
            violates the intellectual property or other rights of any person; (v) is offensive; or (vi) we reject for
            any
            other reason in our sole discretion. When you complete a registration with us, you will be required to
            provide
            certain personal information. You agree that such information will be true, accurate and complete, and that
            you
            will update this information promptly when it changes. If you provide any information that is false or
            inaccurate, not current, or incomplete, or if we suspect that your information is false or inaccurate, not
            current, or incomplete, we may, in our sole discretion, suspend or terminate your right to access any
            material
            for which registration is required. Any personal information supplied hereunder will be handled subject to
            the
            terms of the Privacy Policy. </p>
        <br>
        <p>B. <b class="underline">Account, Password and Security.</b> You are the sole authorized user of your account.
            You are responsible for
            maintaining the confidentiality of any username, password and account provided by you or us for accessing
            the
            App. You are solely and fully responsible for all activities that occur using your password or account.
            Ascendion has no control over the use of any User's account by the User or third parties and expressly
            disclaims
            any liability resulting from such unauthorized use. Should you suspect that any unauthorized party may be
            using
            your password or account or you suspect any other breach of security, you must contact us immediately at
            ava.communications@Ascendion.com or as described in Section 15. Nothing in this section shall affect
            Ascendion's
            rights to limit or terminate the use of the App, as provided below in Section 15(b).</p>
        <br>
        <p>C. <b class="underline">User Multimedia Content.</b> Ascendion does not own or endorse any photos/video's
            that users post on our site. All
            photos, videos and captions are the sole responsibility of the user. By uploading photos and videos you
            grant
            Ascendion the non-exclusive rights to use, copy, re-purpose, and distribute those photos and videos at our
            discretion. Ascendion reserves the right not to post or to remove any photos, videos or captions at its sole
            discretion.</p>
        <br>
        <p>3. <span class="underline"> Prohibited Conduct on the App.</span> Users shall NOT use the App (including but
            not limited to any Community Areas)
            to do any of the following: </p>
        <br>
        <p>A. Upload files that contain viruses, Trojans, corrupted files, or any other similar software that may damage
            the
            operation of another's computer;</p>
        <p>B.Upload files that contain software or other material that violates the intellectual property rights or
            rights
            of privacy or publicity of any third party;</p>
        <p>C.Use the App for any purpose or in any manner that is in violation of local, state, national, or
            international
            law; </p>
        <p>D. Reverse engineer, disassemble, decompile, translate, modify, adapt, license, sublicense, alter, copy,
            distribute, hack or interfere with the App, its servers or any connected networks in any manner, or attempt
            to
            do any of the foregoing; </p>
        <p>E. Register to use the App under different usernames or identities, after Ascendion has suspended or
            terminated
            your use of the App; </p>
        <p>F. Use the App in any other way that, in Ascendion’s sole discretion is injurious to Ascendion, third
            parties, or
            otherwise objectionable. </p>
        <p><span class="underline">4. Intellectual Property Rights.</span> The App, and the information, data, content,
            and materials, which it contains,
            ("Ascendion Materials") are the property of Ascendion and/or its affiliates and licensors. The Ascendion
            Materials are protected from unauthorized copying and dissemination by United States copyright law,
            trademark
            law, international conventions, and other intellectual property laws. Ascendion and/or its affiliates and
            licensors are and shall continue to be the sole and exclusive owner of all right, title and interest in and
            to
            all intellectual property rights associated with the Ascendion Materials. Any use of Ascendion Materials,
            other
            than as expressly permitted herein, is prohibited without the prior permission of Ascendion and/or the
            relevant
            right holder. </p>
        <br>
        <p><span class="underline">5. Copyright Complaints and Copyright Agent.</span> Ascendion respects the
            intellectual property of others, and expects
            Users to do the same. Ascendion will respond to properly submitted notices of alleged copyright infringement
            that comply with applicable law. Ascendion's contact information for notice of alleged copyright
            infringement is
            described in Section 15. </p>
        <br>
        <p>6. <span class="underline">The App / Mobile Devices </span></p>
        <br>
        <p>A. The App may allow you to access our services, upload content to the App, and receive messages on your
            mobile
            device (collectively “Mobile Features”). Your mobile device carrier may prohibit or restrict certain Mobile
            Features and certain Mobile Features may be incompatible with your mobile device carrier or mobile device.
            In
            addition, your mobile device carrier may charge you for standard messaging, data, and other fees to
            participate
            in Mobile Features. We have no responsibility or liability for any fees or charges you incur when using the
            Mobile Features. You should check with your mobile device carrier to find out whether any fees or charges
            will
            apply, what plans are available, and how much they cost. You should also contact your mobile device carrier
            with
            any other questions regarding these issues. </p>
        <p>B. You acknowledge that your use of the App is subject to any terms set forth in the terms of service of the
            third party providing the mobile device on which the App operates (e.g., Apple iOS).</p>
        <p>C. Ascendion is not liable if you do not have a compatible mobile device or if you download the wrong version
            of
            an App for your mobile device. Ascendion reserves the right to terminate your use of the App or any other
            aspect
            of the App should you be using the App with an incompatible or unauthorized device. </p>
        <p>D. <span class="underline"> Store Sourced Application.</span> </p>
        <p>1. If you access the App through, or download it from, the Apple App Store ("App Store Sourced Application"),
            you
            will use the App Store Sourced Application only: (i) on an Apple-branded product that runs iOS (Apple’s
            proprietary operating system software) that you own or control; and (ii) as permitted by the "Usage Rules"
            set
            forth in the Apple App Store Terms of Service. Ascendion reserves all rights in and to the App not expressly
            granted to you under this Agreement. </p>
        <p>2. You acknowledge and agree that (A) this Agreement is valid between you and Ascendion only, (B) Apple is
            not a
            party to this Agreement other than as a third-party beneficiary as contemplated below, and (C) Ascendion,
            not
            Apple, is solely responsible for the App Store Sourced Application and the App content. </p>
        <p>3. Ascendion grants to you a nontransferable license to use the App Store Sourced Application on any
            Apple-branded products that you own or control and as permitted by the Usage Rules in the App Store Terms of
            Service, except that such App Store Sourced Application may be accessed and used by other accounts
            associated
            with your accounts via Family Sharing or volume purchasing. </p>
        <p>4. You acknowledge that Apple has no obligation whatsoever to furnish any maintenance or support services to
            you
            with respect to the App Store Sourced Application. </p>
        <p>5. In the event of any failure of the App Store Sourced Application to conform to any applicable warranty,
            you
            may notify Apple and Apple will refund the purchase price of the App Store Sourced Application to you. To
            the
            maximum extent permitted by applicable law, Apple will have no other warranty obligation whatsoever with
            respect
            to the App Store Sourced Application. </p>
        <p>6. Notwithstanding anything to the contrary herein, and subject to the terms in this Agreement, you
            acknowledge
            that, solely as between Apple and Ascendion, Ascendion and not Apple is responsible for addressing any
            claims
            you may have relating to the App Store Sourced Application, or your possession and/or use thereof,
            including,
            but not limited, to: (i) product liability claims, (ii) any claim that the App Store Sourced Application
            fails
            to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer
            protection
            or similar legislation. </p>
        <p>7. Further, you agree that if the App Store Sourced Application, or your possession and use of the App Store
            Sourced Application, infringes on a third party's intellectual property rights, you will not hold Apple
            responsible for the investigation, defense, settlement and discharge of any such intellectual property
            infringement claims. </p>
        <p>8. You acknowledge and agree that Apple, and Apple's subsidiaries, are third-party beneficiaries of this
            subsection of the Agreement regarding App Store Sourced Applications, and that, upon your acceptance of the
            terms and conditions of this Agreement, Apple will have the right (and will be deemed to have accepted the
            right) to enforce this subsection of the Agreement regarding App Store Sourced Applications against you as a
            third-party beneficiary thereof. </p>
        <p>9. You represent and warrant that (A) you are not located in a country that is subject to a U.S. Government
            embargo, or that has been designated by the U.S. Government as a “terrorist supporting” country; and (B) you
            are
            not listed on any U.S. Government list of prohibited or restricted parties. </p>
        <p>10. You agree to comply with any applicable terms of agreement when using the App Stored Sourced Application,
            for
            example, your wireless data service agreement</p>
        <br>
        <p>7. <span class="underline">Disclaimer of Warranties; Limitation of Liability.</span></p>
        <p>1. Disclaimer of Warranty. YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE APP IS AT YOUR SOLE RISK. TO
            THE
            MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE, WITH ALL FAULTS
            AND
            WITHOUT WARRANTY OF ANY KIND, AND Ascendion HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS WITH RESPECT TO
            THE
            APP, EITHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES AND/OR
            CONDITIONS OF MERCHANTABILITY, OF SATISFACTORY QUALITY, OF FITNESS FOR A PARTICULAR PURPOSE, OF ACCURACY, OF
            QUIET ENJOYMENT, AND OF NONINFRINGEMENT OF THIRD-PARTY RIGHTS, NO ORAL OR WRITTEN INFORMATION OR ADVICE
            GIVEN BY
            Ascendion OR ITS AUTHORIZED REPRESENTATIVE SHALL CREATE A WARRANTY, YOU UNDERSTAND THAT THE INFORMATION
            PROVIDED
            IN THE APP ABOUT PROSPECTIVE WORKERS, INCLUDING THEIR SKILLS AND QUALIFICATIONS, IS PROVIDED BY THE
            PROSPECTIVE
            WORKERS. Ascendion MAKES NO REPRESENTATION OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, REGARDING THE
            ACCURACY
            OR COMPLETENESS OF THIS INFORMATION. </p>
        <p>SHOULD THE APP PROVE DEFECTIVE, YOU ASSUME THE ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR, OR CORRECTION.
            SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR LIMITATIONS ON APPLICABLE STATUTORY
            RIGHTS OF A CONSUMER, SO THE EXCLUSIONS AND LIMITATIONS IN THIS SECTION MAY NOT APPLY TO YOU. </p>
        <p>2. Limitation of Liability. TO THE EXTENT NOT PROHIBITED BY LAW, IN NO EVENT SHALL Ascendion BE LIABLE FOR
            PERSONAL INJURY OR ANY INCIDENTAL, SPECIAL, INDIRECT, OR CONSEQUENTIAL DAMAGES WHATSOEVER, INCLUDING,
            WITHOUT
            LIMITATION, DAMAGES FOR LOSS OF PROFITS, LOSS OF DATA, BUSINESS INTERRUPTION, OR ANY OTHER COMMERCIAL
            DAMAGES OR
            LOSSES, ARISING OUT OF OR RELATED TO YOUR USE OF OR INABILITY TO USE THE APP, HOWEVER CAUSED, REGARDLESS OF
            THE
            THEORY OF LIABILITY (CONTRACT, TORT, OR OTHERWISE) AND EVEN IF Ascendion HAS BEEN ADVISED OF THE POSSIBILITY
            OF
            SUCH DAMAGES, SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OF LIABILITY FOR PERSONAL INJURY, OR OF
            INCIDENTAL
            OR CONSEQUENTIAL DAMAGES, SO THIS LIMITATION MAY NOT APPLY TO YOU. In no event shall the aggregate liability
            of
            Ascendion exceed the amount you paid Ascendion, if any, in the past year for the products or services giving
            rise to the claim. </p>
        <p>3. BY USING THE APP, YOU AGREE THAT THE EXCLUSIONS AND LIMITATIONS OF LIABILITY SET OUT IN THIS AGREEMENT ARE
            REASONABLE. IF YOU DO NOT BELIEVE THEY ARE REASONABLE, YOU MUST NOT USE THE APP. </p>
        <br>
        <p>YOU ACCEPT THAT, AS A CORPORATION, Ascendion HAS AN INTEREST IN LIMITING THE PERSONAL LIABILITY OF ITS
            OFFICERS,
            DIRECTORS AND EMPLOYEES. YOU AGREE THAT YOU WILL NOT BRING ANY CLAIM PERSONALLY AGAINST Ascendion'S
            OFFICERS,
            DIRECTORS OR EMPLOYEES IN CONNECTION WITH ANY DISPUTE, LOSS, OR DAMAGE ARISING OUT OF YOUR USE OF THE APP.
            WITHOUT PREJUDICE TO THE FOREGOING, YOU AGREE THAT THE LIMITATIONS OF WARRANTIES AND LIABILITY SET OUT IN
            THIS
            AGREEMENT WILL PROTECT THE Ascendion'S OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, LICENSORS, PARENTS,
            SUBSIDIARIES,
            AFFILIATES, SUCCESSORS, ASSIGNS, AND SUB-CONTRACTORS, AS WELL AS Ascendion. </p>
        <br>
        <p>CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN
            DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS, EXCLUSIONS, OR LIMITATIONS MAY
            NOT
            APPLY TO YOU, AND YOU MIGHT HAVE ADDITIONAL RIGHTS. </p>
        <p>8. <span class="underline">Mutual Arbitration Agreement.</span></p>
        <p>A. Covered Claims. YOU AND Ascendion MUTUALLY AGREE THAT ALL CLAIMS OR DISPUTES, PAST, PRESENT, OR FUTURE,
            THAT
            YOU MAY HAVE AGAINST Ascendion OR THAT Ascendion MAY HAVE AGAINST YOU, INCLUDING ANY CLAIM OR DISPUTE
            ARISING
            OUT OF OR RELATED TO THE APP OR THIS AGREEMENT OR A VIOLATION OF THIS AGREEMENT, UNLESS SPECIFICALLY
            EXCLUDED
            BELOW, SHALL BE DECIDED BY AN ARBITRATOR THROUGH ARBITRATION AND NOT BY A JUDGE OR JURY OR ANY OTHER
            ADJUDICATORY PROCEEDING (“Arbitration Agreement”). However, the only claims and disputes subject to
            arbitration
            are those that, in the absence of this Arbitration Agreement, could be brought under applicable law.</p>
        <p>Additionally, the Arbitrator, and not any federal, state, or local court or agency, shall have the exclusive
            authority to resolve any dispute relating to the interpretation, applicability, enforceability or formation
            of
            the Arbitration Agreement. However, the preceding sentence shall not apply to the Class Action Waiver
            described
            in Section 8(d) below. Regardless of anything else in this Agreement and/or the American Arbitration
            Association
            (“AAA”) rules or procedures, any dispute relating to the interpretation, applicability, enforceability or
            formation of the Class Action Waiver may only be determined by a court and not an arbitrator. </p>
        <p>B. Governing Law. This Arbitration Agreement and this Section 8 are governed by the Federal Arbitration Act
            (9
            U.S.C. § 1 et seq.) (“FAA”). </p>
        <p>C. Excluded Claims and Disputes. You and Ascendion agree that the following claims or disputes are excluded
            from
            and not covered by this Arbitration Agreement: (1) any claim or dispute seeking to enforce or protect, or
            concerning the validity of, any of your or Ascendion's intellectual property rights; (2) individual claims
            brought in small claims court; (3) any claim that an applicable federal statute expressly states cannot be
            arbitrated; and (4) any claim for injunctive relief. Additionally, nothing in this Arbitration Agreement
            prevents the making a report to or filing a claim or charge with a government agency.</p>
        <p>D. WAIVER OF RIGHT TO BE A PLAINTIFF OR CLASS MEMBER IN A CLASS ACTION. The parties agree to bring any claim
            or
            dispute in arbitration on an individual basis only, and not as a class or collective action, and there will
            be
            no right or authority for any claim or dispute to be brought, heard or arbitrated as a class or collective
            action ("Class Action Waiver"). </p>
        <p>E. Rules/Standards Governing Proceeding. The arbitration will be conducted before a single arbitrator under
            the
            Commercial Arbitration Rules (the "AAA Rules") of the AAA and, where appropriate, the AAA's Supplementary
            Procedures for Consumer Related Disputes ("AAA Consumer Rules"), both of which are available at the AAA
            website
            (www.adr.org). </p>
        <br>
        <p>A party who wishes to arbitrate a claim or dispute covered by this Arbitration Agreement must initiate an
            arbitration proceeding no later than the expiration of the statute of limitations that applicable law
            prescribes
            for the claim asserted. The arbitrator shall apply the statute of limitations that would have applied if the
            claim or dispute had been brought in court. The arbitrator may award any remedy to which a party is entitled
            under applicable law and this Agreement, but remedies shall be limited to those that would be available to a
            party in his or her individual capacity. No remedies that otherwise would be available under applicable law
            will
            be forfeited. The arbitrator shall apply the substantive federal, state, or local law applicable to the
            claims
            asserted. The arbitrator is without authority to apply any different substantive law. The parties have the
            right
            to conduct adequate civil discovery and present witnesses and evidence as needed to present their cases and
            defenses, and any dispute in this regard shall be decided by the arbitrator. The arbitration proceeding
            shall
            take place in the city or county where you reside unless each party agrees otherwise. A court of competent
            jurisdiction shall have the authority to enter judgment upon the arbitrator's decision/award. </p>
        <p>The fees for administering the arbitration and your share of arbitrator compensation will be governed by the
            AAA
            Rules (and, where appropriate, limited by the AAA Consumer Rules). In all cases where required by law,
            Ascendion
            will pay the Arbitrator's fees and the fee for administering the arbitration. If under applicable law
            Ascendion
            is not required to pay all of the arbitrator's and/or arbitration fees, such fee(s) will be apportioned in
            accordance with applicable law and the AAA Rules and/or AAA Consumer Rules, and any disputes in that regard
            will
            be resolved by the arbitrator. Parties are responsible for their own attorney's fees, subject to any
            remedies to
            which that party may later be entitled under applicable law. </p>
        <br>
        <p>9.<span class="underline"> Governing Law; Jurisdiction.</span> Except for the Arbitration Agreement in
            Section 8, which is governed by the
            Federal Arbitration Act, this Agreement is governed and interpreted pursuant to the laws of the State of New
            Jersey, United States of America, without reference to its conflicts of law provisions. For all Disputes not
            subject to arbitration, you agree to submit to the personal and exclusive jurisdiction and venue of the
            courts
            located within Somerset County, New Jersey.</p>
        <br>
        <p>10. <span class="underline">Modifications to the App. </span> Ascendion reserves the right in its sole
            discretion to review, improve, modify or
            discontinue, temporarily or permanently, the App or any content or information on the App with or without
            notice. Ascendion will not be liable to any party for any modification or discontinuance of the App.</p>
        <br>
        <p>11.<span class="underline"> Assignment.</span> This Agreement may not be assigned or transferred by you
            without Ascendion's prior written
            approval. Ascendion may assign or transfer this Agreement without your consent, including but not limited to
            assignments: (i) to a parent or subsidiary corporation, (ii) to an acquirer of assets, or (iii) to any other
            successor or acquirer. Any assignment in violation of this Section 11 shall be null and void. This Agreement
            shall inure to the benefit of permitted successors and assigns. </p>
        <br>
        <p>12. <span class="underline">Term and Termination; Survival.</span> </p>
        <br>
        <p>A. Term. This Agreement shall continue in full force and effect until such time as it is terminated by you or
            by
            us. </p>
        <p>B. Termination by Ascendion. Ascendion may terminate this Agreement or terminate or suspend your right to use
            the
            App at any time for any or no reason (including, without limitation, in the event that Ascendion believes
            that
            you have breached this Agreement or any policy posted on the App, or if Ascendion otherwise finds that you
            have
            engaged in inappropriate and/or offensive behavior (collectively, "Prohibited Conduct")) by providing you
            with
            written or email notice of such termination to the physical or email address you have provided us.
            Termination
            will be effective immediately upon such notice.</p>
        <p>C. Termination by You. You may terminate this Agreement by completely and permanently ceasing to use the App.
        </p>
        <p>D. Survival. All provisions that should by their nature survive the expiration or termination of this
            Agreement,
            including without limitation, Sections 1, 6, 7, 9-11.</p>
        <br>
        <p>13. <span class="underline">General Provisions.</span> No agency, partnership, joint venture,
            employer-employee, or franchiser-franchisee
            relationship is intended or created by this Agreement. A failure by us to enforce any provision(s) of this
            Agreement will not be construed as a waiver of any provision or right. This Agreement constitutes the entire
            agreement between you and Ascendion with respect to its subject matter. If any provision of this Agreement
            is
            found to be invalid or unenforceable, the remaining provisions will be enforced to the fullest extent
            possible,
            and the remaining provisions will remain in full force and effect. You agree that, except as otherwise
            expressly
            provided in this Agreement, there shall be no third-party beneficiaries to this Agreement. All notices
            provided
            by a party in connection with this Agreement will be deemed given as of the day they are received either by
            email, messenger, delivery service, or in the U.S. Mail, postage prepaid, certified or registered, return
            receipt requested, and addressed as follows: Your address for such notices is your email address and/or
            physical
            address that you have provided to Ascendion. Ascendion's address for such notices is described in Section
            15.
            The captions in this Agreement are solely for convenience and shall not affect the interpretation of this
            Agreement. This Agreement shall not be modified except in writing signed by both parties or by means of a
            new
            posting by Ascendion, as described below. This Agreement shall be interpreted as if jointly drafted by the
            parties. Ascendion shall have no liability to you for any failure or delay in performing its obligations in
            this
            Agreement where such failure or delay is caused by an event or circumstance beyond Ascendion's reasonable
            control including, without limitation, strikes, lock-outs and other industrial disputes, breakdown of
            systems or
            network access, flood, fire, explosion, acts of terrorism or accident. </p>
        <br>
        <p>14. <span class="underline">Changes to this Agreement.</span> Except for Section 10 of this Agreement, which
            may only be modified with your
            agreement after notice of the modification, Ascendion reserves the right, in our sole and absolute
            discretion,
            to make changes to any of the terms and conditions of this Agreement at any time. If we change the terms and
            conditions of this Agreement, we will post those changes on this page and update the update date below. If
            we
            materially change the terms and conditions of this Agreement, we will notify you by prominently posting a
            notice
            of such changes before making them and by stating the effective date of the changes. If any future changes
            to
            this Agreement are unacceptable to you or cause you to no longer be in compliance with this Agreement, you
            must
            terminate, and immediately stop using, the App. Your continued use of the App following any revision to this
            Agreement constitutes your complete and irrevocable acceptance of any and all such changes. </p>
        <br>
        <p>15. <span class="underline">Contact Information.</span> If you have any questions regarding this Agreement,
            please contact us at
            ava.communications@Ascendion.com or by mail at: </p>
        <br>
        <p>110 Allen Road </p>
        <p>Basking, Ridge, NJ 07920 </p>
        <p>Last updated: May 25, 2022 </p>

    </div>
</div>